export default __webpack_public_path__ + "static/6-ab793e548e794d61dd344fdde64aef9f.jpg";